// Generated from the approved MagicPath revision 440525530526269440. Do not hand-edit; update the source worktree instead.
import { useState } from 'react';
const dawnPlate = "/assets/page07-day46.jpg";
const navigation = ['METHOD', 'HOUSE 45', 'INSIGHTS', 'ASSESSMENT'];
export const Page07Day46 = () => {
  const [activeNav, setActiveNav] = useState('ASSESSMENT');
  return <main className="day462-page">
    <img className="day462-photo" src={dawnPlate} alt="Calm ocean beneath a pale dawn sky and warm sunrise" />
    <div className="day462-grade" aria-hidden="true" />
    <button className="day462-wordmark" type="button" aria-label="IMTHEHOUSE home">IMTHEHOUSE</button>
    <nav className="day462-navigation" aria-label="Primary navigation">
      {navigation.map(item => <button type="button" key={item} className={activeNav === item ? 'active' : ''} onClick={() => setActiveNav(item)} aria-pressed={activeNav === item}>{item}</button>)}
    </nav>
    <section className="day462-copy" aria-labelledby="day462-heading">
      <p className="day462-eyebrow">DAY 46</p>
      <h1 id="day462-heading">THE SAME FIRE.<br /><span>NO LONGER RUNNING YOUR LIFE.</span></h1>
      <div className="day462-rule" aria-hidden="true" />
      <p className="day462-body">No open bets. No hidden accounts. No Sunday ownership. No broken promise waiting for Monday.</p>
      <p className="day462-body">Rules for your money. Rules for your attention. A plan for your worst hours. Real stakes for the next ninety days.</p>
      <p className="day462-body">The drive is still there. It finally has somewhere worthy to go.</p>
    </section>
    <aside className="day462-anchor"><strong>STAY IN THE PICTURE.</strong><p>The point was never to become a different man.<br />It was to stop disappearing from your own life.</p></aside>
    <footer className="day462-footer"><span>DAY 46</span><i aria-hidden="true" /><strong>YOU ARE THE HOUSE NOW.</strong></footer>
  </main>;
};